(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('verogrove-collection-slider')) {
    class VerogroveCollectionSlider extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.resource-list--grid');
        this.items = Array.from(this.scroller?.querySelectorAll(':scope > .resource-list__item') || []);
        this.current = this.querySelector('[data-verogrove-current]');
        this.frame = null;

        if (!this.scroller || this.items.length === 0) return;

        this.updateActiveItem = this.updateActiveItem.bind(this);
        this.queueUpdate = this.queueUpdate.bind(this);
        this.scroller.addEventListener('scroll', this.queueUpdate, { passive: true });
        window.addEventListener('resize', this.queueUpdate, { passive: true });
        this.updateActiveItem();
      }

      disconnectedCallback() {
        this.scroller?.removeEventListener('scroll', this.queueUpdate);
        window.removeEventListener('resize', this.queueUpdate);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      queueUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.updateActiveItem();
          this.frame = null;
        });
      }

      updateActiveItem() {
        if (!window.matchMedia('(max-width: 749px)').matches) {
          this.items.forEach((item) => item.classList.remove('is-active'));
          return;
        }

        const scrollerRect = this.scroller.getBoundingClientRect();
        const scrollerCenter = scrollerRect.left + scrollerRect.width / 2;
        let activeIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.items.forEach((item, index) => {
          const itemRect = item.getBoundingClientRect();
          const itemCenter = itemRect.left + itemRect.width / 2;
          const distance = Math.abs(scrollerCenter - itemCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        });

        this.items.forEach((item, index) => item.classList.toggle('is-active', index === activeIndex));
        if (this.current) this.current.textContent = String(activeIndex + 1).padStart(2, '0');
      }
    }

    customElements.define('verogrove-collection-slider', VerogroveCollectionSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
